import { UNLOCK_VOD_CONTENT, CLEAR_UNLOCK_VOD_CONTENT } from '../actions/content/constants';
const initialState = {
  unLockVodContent: '',
};

export const unLockVodContent = (state = initialState, action) => {
  switch (action.type) {
    case UNLOCK_VOD_CONTENT:
      return {
        unLockVodContent: action.payload,
      };
    case CLEAR_UNLOCK_VOD_CONTENT:
      return initialState;
    default:
      return state;
  }
};

export default unLockVodContent;
